import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import config from '../../../config/config';

const appUrlPath = `/${config.appUrlPath}`;

class BusinessOccupationType extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {
    axios.get(`${appUrlPath}/getOccupationCV`, {
      params: {}
    })
    .then((res) => {
      this.setState({ option: res.data, isDataLoaded: true });
    })
    .catch(() => {
    });
  }

  render() {
    return (
      <FormGroup controlId="businessOccupationType">
        <Col componentClass={ControlLabel} sm={5}>
          Business / Occupation Type *
        </Col>
        <Col sm={7}>
          {this.state.isDataLoaded ?
            <select
              className="custom-select"
              id="businessOccupationType"
              onChange={this.props.handleChangeBusType}
              value={this.props.busType}
              required
            >
              <option value="">Please select</option>
              {this.state.option.map((obj, index) => {
                const counter = index
                return (
                  <option
                    value={obj.code}
                    key={counter}
                  >{obj.name}</option>
                );
              })}
            </select> : <div>Loading</div>}
        </Col>
      </FormGroup>
    )
  }
}

BusinessOccupationType.propTypes = {
  handleChangeBusType: PropTypes.func,
  busType: PropTypes.string
};

export default BusinessOccupationType;



// WEBPACK FOOTER //
// ./src/app/components/businessOccupationType/BusinessOccupationType.js